import { Card, Stack, Typography, Skeleton } from '@mui/material';
import { useListContext, useResourceContext } from 'react-admin';
import { useSummary } from '../../../providers/SummaryStore';

export default function SummaryCards() {
  const resource = (useResourceContext() as string) ?? 'unknown';
  const { isLoading } = useListContext();
  const summary = useSummary(resource);  
  

  const Money = ({ v = 0 }: { v?: number }) => (
    <>{v.toLocaleString(undefined, { maximumFractionDigits: 2 })}</>
  );

  return (
    <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} sx={{ mb: 2 }}>
      <Card sx={{ p: 2, flex: 1 }}>
        <Typography variant="caption" color="text.secondary">
          Total Fee (USD)
        </Typography>
        <Typography variant="h5" sx={{ mt: 0.5 }}>
          {isLoading && !summary ? <Skeleton width={120} /> : <Money v={summary?.totalFeeUsd} />}
        </Typography>
      </Card>

      <Card sx={{ p: 2, flex: 1 }}>
        <Typography variant="caption" color="text.secondary">
          Total Swaps
        </Typography>
        <Typography variant="h5" sx={{ mt: 0.5 }}>
          {isLoading && !summary ? (
            <Skeleton width={120} />
          ) : (
            (summary?.totalSwaps ?? 0).toLocaleString()
          )}
        </Typography>
      </Card>
    </Stack>
  );
}
